import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import SaleInvoiceServices from "../../services/SaleInvoice";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import Form from "./components/form";

const CreateSale = () => {

  const route = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createSaleInvoice = async (payload) => {
    setLoading(true)
    try {
      await SaleInvoiceServices.createSaleInvoice(payload)
      SuccessToaster('Create Successfully')
      navigate(route?.sales)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Sale</h4>
              <h6>Create new sale invoice</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={createSaleInvoice} loading={loading} />
      </div>
    </div>
  );
};

export default CreateSale;
